import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import config from '../../api/config.json';

import io from 'socket.io-client';

import Header from '../Header';
import Sidebar from '../Sidebar';
import Footer from '../Footer';

import { isAuthenticated } from '../../auth';
import ModifyStore from '../../utils/ModifyStore';

const Wrapper = props => {
  const dispatch = useDispatch();
  const dashboards = useSelector(state => state.dashboards);
  const dash = useSelector(state => state.dashboards.currentDash);
  const modifyStore = ModifyStore(dispatch);

  useEffect(() => {
    const { protocol, ipServerSKT, portServerSKT } = config;
    let socket = { id: '', connected: false, emit: () => {} };

    const timer = setInterval(() => {
      if (!socket.connected) {
        socket = io(`${protocol}://${ipServerSKT}:${portServerSKT}`, {
          reconnection: false
        });
        try {
          socket.on('connect', () => {
            console.log('socket store conected ', socket.id);

            socket.on('responseChangeStore', response => {
              modifyStore(response);
            });

            socket.on('disconnect', () => {
              console.log('socket store disconnected');
              socket.disconnect();
            });
          });
        } catch (err) {
          console.error(err);
        }
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return isAuthenticated() ? (
    <React.Fragment>
      <Header />
      <div
        className={`page-wrapper ${dash.theme} ${
          dashboards.sidebarOpen ? 'toggled' : ''
        }`}
      >
        <Sidebar />
        <div className="page-content">
          <props.component {...props} />
          <Footer />
        </div>
      </div>
    </React.Fragment>
  ) : (
    <Redirect to="/" />
  );
};

Wrapper.propTypes = {
  component: PropTypes.func
};

export default Wrapper;
